/**
 * Priority of Poprs.  Used to sequence multiple Poprs and to change L&F of Poprs
 */
export enum PoprPriority {
  URGENT = 1, // compelling or requiring immediate action - ex. interactive modal popup
  ERROR = 2, //  unintentional deviation from goal or accuracy - ex. api failure
  SUCCESS = 4, // achievement of something desired or planned - ex. save profile achieved
  INFO = 8, // message received and understood - ex. disconnected from network without side affects
  NONE = 16, // unassigned or informal - ex. "good to see you back"
}
